import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-notification@3.3.0@rc-notification/es/index.js
// module id = 316
// module chunks = 0